import { Check, X } from 'lucide-react';

export function SafeIdeaSolution() {
  return (
    <section className="py-20 sm:py-32 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-xl text-center mb-12">
          <h2 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl">
            SafeIdea: All Three, No Compromise
          </h2>
        </div>

        <div className="mx-auto max-w-3xl">
          {/* Comparison Table */}
          <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
            <table className="w-full">
              <thead>
                <tr className="bg-gray-50">
                  <th className="px-6 py-4 text-left text-base font-semibold text-gray-900"></th>
                  <th className="px-6 py-4 text-center text-base font-semibold text-gray-900">
                    Structured
                    <br />
                    Workflows
                  </th>
                  <th className="px-6 py-4 text-center text-base font-semibold text-gray-900">
                    Affordable
                  </th>
                  <th className="px-6 py-4 text-center text-base font-semibold text-gray-900">
                    Secure
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                <tr>
                  <td className="px-6 py-4 text-base font-medium text-gray-900">General AI</td>
                  <td className="px-6 py-4 text-center">
                    <X className="h-6 w-6 text-red-500 mx-auto" />
                  </td>
                  <td className="px-6 py-4 text-center">
                    <Check className="h-6 w-6 text-green-500 mx-auto" />
                  </td>
                  <td className="px-6 py-4 text-center">
                    <X className="h-6 w-6 text-red-500 mx-auto" />
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 text-base font-medium text-gray-900">
                    Enterprise Legal AI
                  </td>
                  <td className="px-6 py-4 text-center">
                    <Check className="h-6 w-6 text-green-500 mx-auto" />
                  </td>
                  <td className="px-6 py-4 text-center">
                    <X className="h-6 w-6 text-red-500 mx-auto" />
                  </td>
                  <td className="px-6 py-4 text-center">
                    <Check className="h-6 w-6 text-green-500 mx-auto" />
                  </td>
                </tr>
                <tr className="bg-teal-50 border-2 border-teal-400">
                  <td className="px-6 py-4 text-lg font-bold text-teal-700">SafeIdea</td>
                  <td className="px-6 py-4 text-center">
                    <Check className="h-6 w-6 text-green-600 mx-auto" />
                  </td>
                  <td className="px-6 py-4 text-center">
                    <Check className="h-6 w-6 text-green-600 mx-auto" />
                  </td>
                  <td className="px-6 py-4 text-center">
                    <Check className="h-6 w-6 text-green-600 mx-auto" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Explanatory text */}
          <div className="mt-8 grid gap-4 sm:grid-cols-3 text-center text-sm">
            <div className="p-4 bg-gray-50 rounded-lg">
              <p className="font-medium text-gray-900">General AI</p>
              <p className="text-gray-600 mt-1">ChatGPT, Claude.ai</p>
            </div>
            <div className="p-4 bg-gray-50 rounded-lg">
              <p className="font-medium text-gray-900">Enterprise Legal AI</p>
              <p className="text-gray-600 mt-1">Harvey, CoCounsel</p>
            </div>
            <div className="p-4 bg-teal-50 rounded-lg border border-teal-200">
              <p className="font-medium text-teal-700">SafeIdea</p>
              <p className="text-lg text-gray-600 mt-2 font-medium">
                Built for all Legal Professionals
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
